module.exports = __webpack_public_path__ + "static/media/RED.fb69230b.png";